import type { StationId } from '@/domain/types';
import type {
  LocalAuthListVersionRepository,
  LocalAuthListVersionRow,
} from '@/persistence/ports';
import type { Evse3Database } from '../db';

/**
 * SPEC-001 — single-row-per-station table tracking the current
 * LocalAuthList version integer (OCPP 1.6J §6.5). Default 0 when no
 * entries exist.
 */
export class LocalAuthListVersionRepositoryDexie
  implements LocalAuthListVersionRepository
{
  constructor(private readonly db: Evse3Database) {}

  async get(stationId: StationId): Promise<LocalAuthListVersionRow | null> {
    const row = await this.db.localAuthListVersions.get(stationId);
    return row ?? null;
  }

  async set(stationId: StationId, listVersion: number): Promise<void> {
    await this.db.localAuthListVersions.put({
      stationId,
      listVersion,
      updatedAt: Date.now(),
    });
  }

  async delete(stationId: StationId): Promise<void> {
    await this.db.localAuthListVersions.delete(stationId);
  }
}
